import { mutatorAction } from "satcheljs";
import muteScheduleGroupDialogStore from "../store/store";

/**
 * Shows the mute/unmute schedule group confirmation dialog
 * @param actionTaken - The action to be taken if confirmed (mute or unmute)
 * @param onConfirm - Callback to execute when user confirms
 * @param onCancel - Callback to execute when user cancels (optional)
 */
const showMuteScheduleGroupDialog = mutatorAction(
    "showMuteScheduleGroupDialog",
    (actionTaken: "mute" | "unmute", onConfirm: () => void, onCancel?: () => void) => {
        muteScheduleGroupDialogStore().isShown = true;
        muteScheduleGroupDialogStore().actionTaken = actionTaken;
        muteScheduleGroupDialogStore().onConfirm = onConfirm;
        muteScheduleGroupDialogStore().onCancel = onCancel || null;
    }
);

export default showMuteScheduleGroupDialog;
